/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from '@material-ui/core';
import useCompany from '../../hooks/useCompany';
import { useEffect, useState } from 'react';
import TasksBox from '../../pages/adds/TasksBox';
import CollectiveitemsAlsardal from '../shared/CollectiveitemsAlsardal';
import RentitemsStockAlsardal from '../shared/RentitemsStockAlsardal';
import useRentitems from '../../hooks/useRentitems';
import useCollectiveitems from '../../hooks/useCollectiveitems';

function getUniqueItemsWithQty(items: any) {
  const uniqueItems = {};
  for (const item of items) {
    if (uniqueItems[item.itemId]) {
      uniqueItems[item.itemId].qty += item.qty;
    } else {
      uniqueItems[item.itemId] = { ...item };
    }
  }
  const result = Object.values(uniqueItems);
  return result;
}

function mergeItemsWithQty(stockItems: any, busyItems: any) {
  const mergedItems = {};

  // Merge the stockItems with the mergedItems object
  for (const item of stockItems) {
    if (mergedItems[item._id]) {
      mergedItems[item._id].stock_qty += item.qty;
    } else {
      mergedItems[item._id] = { ...item, busy_qty: 0, stock_qty: item.qty };
    }
  }

  // Merge the busyItems with the mergedItems object
  for (const item of busyItems) {
    if (mergedItems[item.itemId]) {
      mergedItems[item.itemId].busy_qty += item.qty;
    } else {
      mergedItems[item.itemId] = { ...item, busy_qty: item.qty, stock_qty: 0 };
    }
  }

  // Convert the mergedItems object into an array
  const mergedResult = Object.values(mergedItems);

  return mergedResult;
}

function updatePackageItemsWithStockQty(packageItems: any, stockItems: any) {
  const updatedPackageItems = packageItems.map((packageItem: any) => {
    const stockItem = stockItems.find(
      (item: any) => item._id === packageItem._id
    );
    const stockQty = stockItem ? stockItem.qty - stockItem.busy_qty : 0;
    const itemqty = packageItem.itemqty;
    const isrent = packageItem.itemType === 4;
    return {
      ...packageItem,
      stock_qty: stockQty,
      isred: isrent && itemqty > stockQty,
    };
  });

  return updatedPackageItems;
}

function checkIsRed(list: any) {
  for (const item of list) {
    if (item.isred === true) {
      return true;
    }
  }
  return false;
}

const readyCollItems = ({ collectiveitems, frentitems }: any) => {
  const oldcollitems = [...collectiveitems];
  if (frentitems?.length > 0) {
    if (oldcollitems?.length > 0) {
      const rcollitems = oldcollitems.map((ci: any) => {
        if (ci?.items?.length > 0) {
          const ni = updatePackageItemsWithStockQty(ci?.items, frentitems);
          const isred = checkIsRed(ni);
          return { ...ci, items: ni, isred };
        } else {
          return ci;
        }
      });
      return rcollitems;
    }
  }
  return collectiveitems;
};

function AlsardalOrder({ isRTL, theme, words }) {
  const [start, setStart] = useState(new Date());
  const [end, setEnd] = useState(new Date());
  const [tasks, setTasks] = useState([]);
  const [rentitemslist, setrentitemslist] = useState([]);

  const { company } = useCompany();
  const { rentitems } = useRentitems();
  const { collectiveitems } = useCollectiveitems();
  const frentitems = rentitemslist?.length > 0 ? rentitemslist : rentitems;
  const readycollitems = readyCollItems({ collectiveitems, frentitems });
  useEffect(() => {
    const itemslist = [];
    if (tasks && tasks.length > 0) {
      for (const tsk of tasks) {
        if (tsk.items && tsk.items.length > 0) {
          itemslist.push(...tsk.items);
        }
      }
    } else {
      setrentitemslist([]);
    }
    if (itemslist?.length > 0) {
      const bfitems = itemslist.filter((itm: any) => itm.itemType === 4);
      const fitems = getUniqueItemsWithQty(bfitems);
      const ffitems = mergeItemsWithQty(rentitems, fitems);
      setrentitemslist(ffitems);
    }
  }, [tasks]);
  return (
    <Box style={{ paddingTop: 5, paddingBottom: 5 }}>
      <CollectiveitemsAlsardal
        collectiveitemslist={readycollitems}
        isRTL={isRTL}
        words={words}
        theme={theme}
        color={undefined}
        start={start}
        setStart={setStart}
        end={end}
        setEnd={setEnd}
      ></CollectiveitemsAlsardal>
      <RentitemsStockAlsardal
        rentitems={frentitems}
        isRTL={isRTL}
        words={words}
        theme={theme}
        color={undefined}
        start={start}
        end={end}
      ></RentitemsStockAlsardal>
      <Box style={{ paddingBottom: 5 }}>
        <TasksBox
          isRTL={isRTL}
          words={words}
          theme={theme}
          company={company}
          start={start}
          end={end}
          setTasks={setTasks}
        ></TasksBox>
      </Box>
    </Box>
  );
}

export default AlsardalOrder;
